export class ContactType {
  constructor() {
    this.id = "";
    this.name = "";
    this.createdBy = "";
  }
}
